<script setup lang="ts">
import SVG from "@/stories/displays/SVG/SVG.vue";

defineEmits<{
  click: [];
}>();
</script>

<template>
  <button
    type="button"
    class="bg-white rounded-full w-8 h-8 min-w-8 min-h-8 border border-neutral300 shadow-small z-50 hover:bg-neutral100 transition-colors focus-visible-base flex justify-center items-center"
    @click="$emit('click')"
  >
    <slot>
      <SVG icon="fas-elipsis" height="1.25rem" width="1.25rem" />
    </slot>
  </button>
</template>
